import React, { createContext, useContext } from "react";
import { useHomeRepository } from "../repository/Home.repository";

let operationsAllowed: any = {};
const HomeServiceContext = createContext(operationsAllowed);

export const HomeServiceProvider = (props: any) => {
  // const coreService = useCoreService();
  const homeRepository = useHomeRepository();

  const getNotifications = () => {
      return homeRepository.getNotifications();
  }

  operationsAllowed = {
    getNotifications
  }

  return (
    <HomeServiceContext.Provider value={operationsAllowed}>
      {props.children}
    </HomeServiceContext.Provider>
  );
}

export const useHomeService = () => {
  return useContext(HomeServiceContext);
}